// extracted by mini-css-extract-plugin
export var breadcrumb = "6";
export var chatIcon = "999";
export var chatOverlay = "9998";
export var clubFacilitiesHeader = "20";
export var cookies = "40";
export var dropShadow = "1";
export var dropdown = "7";
export var header = "50";
export var mobileNav = "60";
export var overlay = "10";
export var pageNavigation = "2";
export var popup = "55";
export var popupCloseButton = "99";
export var recaptchaBadgePopup = "56";
export var sliderOverlay = "10";
export var wholePageOverlay = "9999";
export var wholePagePopup = "100";